export default __webpack_public_path__ + "static/media/image.study-buddy-zone.ec9602c8.png";